import { PRODUCTION } from "@irati/utils/constants/environment";
import env from "@irati/utils/env";
export var getFidelCredentials = function () {
    var isProduction = env.ENVIRONMENT_NAME === PRODUCTION;
    return {
        programId: isProduction ? "15056e41-a4c8-41fa-b864-77fff6e1c776" : "09d2a455-c062-420d-aaa3-860399b1abeb",
        publicKey: isProduction ? "pk_live_a6fe318a-1ae9-4a37-b7b9-a63bde340821" : "pk_test_3a7a169a-accd-4827-8e81-a872d8e979d4"
    };
};
